export default {
  zh: {
    MyInvitationCode: '我的邀请码',
    explain: '将上面的邀请码或者邀请链接发送给您的好友，邀请他使用 Plex加速器。好友充值成功，您将获得相应的免费时长奖励。好友越多送得越多',
    invitationCode: '邀请码'
  },
  en: {
    MyInvitationCode: 'My Invitation Code',
    explain: "Send the invitation code or referral link to your friends, and invite them to use PlexVPN. You'll get free VIP service time once your friend successfully purchase a plan. There are no limits to the rewards, the more friends you invite, the more free VIP service time you’ll get",
    invitationCode: 'Invitation Code'
  }
}



// WEBPACK FOOTER //
// ./src/components/inviteFriend/lang.js